import { useAppSelector } from '@web-common/state/createStore';
import { api, apis } from 'api';
import debounce from 'lodash/debounce';
import React, { useCallback, useEffect, useRef, useState, useImperativeHandle } from 'react';
import SearchList from '../searchList';
import styles from './index.module.scss';
const productApi = api.requireLogicalApi(apis.productAuthApiImpl);
const SelectList = React.forwardRef((props, ref) => {
    const { showAddTeamBtn, showAddPersonalBtn, searchValue, disableCheckList, onSelect, isIM, multiple = true, showCheckbox = true, type = ['personal', 'enterprise', 'team', 'recent'], searchType = 'all', searchListProps, excludeSelf, useContactId, useEdm, isCustomerFirst = false, accountRootKey, noRelateEnterprise, containerHeight, useOrgUnit, flattenPersonalEmails = false, deduplicationByEmail = true, } = props;
    const [selectList, setSelectList] = useState([]);
    const contactListRef = useRef(null);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const showAndUseEdm = useEdm && !!productApi.getABSwitchSync('edm_mail');
    const handleSelect = (itemList, data) => {
        console.info('handleSelect', itemList, data);
        setSelectList(itemList);
        if (!onSelect) {
            return;
        }
        if (multiple) {
            onSelect(itemList, data);
        }
        else {
            onSelect(itemList, data);
        }
    };
    const debounceSearchChange = useCallback(debounce(value => {
        var _a;
        (_a = contactListRef === null || contactListRef === void 0 ? void 0 : contactListRef.current) === null || _a === void 0 ? void 0 : _a.handleInputChange(value);
    }, 700), []);
    useEffect(() => {
        debounceSearchChange(searchValue);
    }, [searchValue]);
    useImperativeHandle(ref, () => ({
        handleInputEnter: e => {
            var _a;
            (_a = contactListRef.current) === null || _a === void 0 ? void 0 : _a.handleInputEnter(e);
        },
        handleInputKeyDown: e => {
            var _a;
            (_a = contactListRef.current) === null || _a === void 0 ? void 0 : _a.handleInputKeyDown(e);
        },
        handleInputChange: e => {
            var _a;
            (_a = contactListRef.current) === null || _a === void 0 ? void 0 : _a.handleInputChange(e);
        },
    }));
    return (React.createElement("div", { className: styles.selectContainer },
        React.createElement("div", { className: styles.contactTreeTab, style: { height: containerHeight || undefined } },
            React.createElement(SearchList, Object.assign({ accountRootKey: accountRootKey, useEdm: showAndUseEdm, isCustomerFirst: showAndUseEdm && isCustomerFirst, excludeSelf: excludeSelf, isIM: isIM, type: searchType, useContactId: useContactId, useOrgUnit: useOrgUnit, showCheckbox: showCheckbox, showAddTeamBtn: showAddTeamBtn, showAddPersonalBtn: showAddPersonalBtn, multiple: multiple, ref: contactListRef, disableCheckList: disableCheckList, defaultSelectList: selectList, onSelect: handleSelect, noRelateEnterprise: noRelateEnterprise, flattenPersonalEmails: flattenPersonalEmails, deduplicationByEmail: deduplicationByEmail }, searchListProps)))));
});
export default SelectList;
